var $a018d8aa5c8a7493$exports = {};
document.querySelectorAll('.sidebar li a').forEach((element)=>{
    element.classList.remove('bg-active', 'text-active-text');
});
document.querySelectorAll('.sidebar li:nth-child(3) a').forEach((element)=>{
    element.classList.add('bg-active', 'text-active-text');
}); // import("./breadcrumbs.js").then(function (breadcrumb) {
 //     breadcrumb.setCrumbs({
 //         1: {
 //             href: "leaderboard.html",
 //             text: "Leaderboard"
 //         },
 //         2: {
 //             href: "",
 //             text: "#1 Lindsay Walton"
 //         }
 //     });
 // });


//# sourceMappingURL=arthur-romagnolo.ac13c5bb.js.map
